import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Spinner,
    TextControl,
    SelectControl
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';  // Assuming deleteData is your helper function to handle DELETE requests

const EnquiryListTab = ({ openPopup }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filterKey, setFilterKey] = useState('');
    const [filterValue, setFilterValue] = useState('');

    useEffect(() => {
        fetchEnquiries(currentPage, startDate, endDate, filterKey, filterValue);
    }, [currentPage]);

    const handleFilter = () => {
        setCurrentPage(1);
        fetchEnquiries(1, startDate, endDate, filterKey, filterValue);
    };

    const clearFilter = () => {
        setStartDate('');
        setEndDate('');
        setFilterKey('');
        setFilterValue('');
        setCurrentPage(1);
        fetchEnquiries(1, '', '', '', '');
    };

    const fetchEnquiries = (page, start, end, fKey, fValue) => {
        setLoading(true);
        let url = `${gmwqp_wp_ajax.getenquirys}?page=${page}&per_page=10`;
        if (start) url += `&start_date=${start}`;
        if (end) url += `&end_date=${end}`;
        if (fKey && fValue) {
            url += `&filter_key=${fKey}&filter_value=${fValue}`;
        }

        fetchData(url, gmwqp_wp_ajax.nonce)
            .then((response) => {
                setData(response.enquiry || []);
                setHeaders(response.header ? Object.entries(response.header) : []);
                setTotalPages(response.pagination?.total_pages || 1);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching enquiries:', error);
            });
    };

    // Function to delete all enquiries
    const deleteAllEnquiries = () => {
        if (window.confirm("Are you sure you want to delete all enquiries?")) {
            setLoading(true);
            saveData(gmwqp_wp_ajax.deleteallenquirys, gmwqp_wp_ajax.nonce)  // Assuming deleteData handles the DELETE API call
                .then((response) => {
                    setLoading(false);
                    if (response.success) {
                        openPopup('All enquiries have been deleted!');
                        fetchEnquiries(currentPage, startDate, endDate, filterKey, filterValue);  // Re-fetch the enquiries after deletion
                    } else {
                        openPopup('Failed to delete enquiries.');
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.error('Error deleting enquiries:', error);
                    openPopup('Failed to delete enquiries.');
                });
        }
    };

    const deleteEnquiry = (id) => {
        if (window.confirm("Are you sure you want to delete this enquiry?")) {
            setLoading(true);
            saveData(gmwqp_wp_ajax.deleteallenquirys, gmwqp_wp_ajax.nonce, { id })  // Assuming the API takes the ID of the enquiry to delete
                .then((response) => {
                    setLoading(false);
                    if (response.success) {
                        openPopup('Enquiry deleted successfully!');
                        fetchEnquiries(currentPage, startDate, endDate, filterKey, filterValue);  // Re-fetch the enquiries after deletion
                    } else {
                        openPopup('Failed to delete enquiry.');
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.error('Error deleting enquiry:', error);
                    openPopup('Failed to delete enquiry.');
                });
        }
    };


    return (
        <PanelBody>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    {/* Delete All Button */}
                    <div >
                        <Button
                            isPrimary
                            onClick={deleteAllEnquiries}
                            className="mb-10"
                        >
                            Delete All Enquiries
                        </Button>
                        <Button
                            isPrimary
                            onClick={() => window.open(`${gmwqp_wp_ajax.site_url}/?action=download_enquiery_data`, '_blank')}
                            className="ml-10"
                        >
                            Download All Enquiries
                        </Button>

                    </div>
                    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'end' }}>
                        <div>
                            <label>Start Date</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ddd', display: 'block' }}
                            />
                        </div>
                        <div>
                            <label>End Date</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ddd', display: 'block' }}
                            />
                        </div>
                        <div style={{ minWidth: '150px' }}>
                            <SelectControl
                                label="Filter By"
                                value={filterKey}
                                options={[
                                    { label: 'Select Field', value: '' },
                                    ...headers.filter(([key]) => key !== 'id' && key !== 'date').map(([key, value]) => ({ label: value, value: key }))
                                ]}
                                onChange={setFilterKey}
                            />
                        </div>
                        <div>
                            <TextControl
                                label="Search Value"
                                value={filterValue}
                                onChange={setFilterValue}
                            />
                        </div>
                        <Button
                            isPrimary
                            onClick={handleFilter}
                            style={{ marginBottom: '8px' }}
                        >
                            Filter
                        </Button>
                        <Button
                            isSecondary
                            onClick={clearFilter}
                            style={{ marginBottom: '8px' }}
                        >
                            Clear
                        </Button>
                    </div>
                    <div className="cfcblist">
                        <table className="wp-list-table widefat fixed striped table-view-list">
                            <thead>
                                <tr>
                                    {headers.map(([key, value]) => (
                                        <th key={key}>{value}</th>
                                    ))}
                                    <th>Actions</th>
                                </tr>

                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.id}>
                                            {headers.map(([key]) => (
                                                <td key={key}>{item[key] || 'N/A'}</td>
                                            ))}
                                            <td>
                                                <Button
                                                    isPrimary
                                                    onClick={() => deleteEnquiry(item.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={headers.length + 1} style={{ textAlign: 'center' }}>No enquiries found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div style={{ marginTop: '10px', textAlign: 'center' }}>
                        <Button
                            isSecondary
                            disabled={currentPage <= 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                        >
                            Previous
                        </Button>
                        <span style={{ margin: '0 10px' }}> Page {currentPage} of {totalPages} </span>
                        <Button
                            isSecondary
                            disabled={currentPage >= totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                        >
                            Next
                        </Button>
                    </div>


                </>
            )}
        </PanelBody>
    );
};

export default EnquiryListTab;
